import { Application } from "Application";
import * as Constants from "Data/Constants";
import * as VO from "Data/VO";
import { Button } from "GameObjects/Button";
import { TimelineLite } from "gsap/TimelineLite";
import * as HLF from "html-living-framework";
import { makeSprite } from "html-living-framework/lib/Utils/PixiUtils";

const bgm = "LATW_1189_1_happy_pacer_jazz_New_Orleans_KK";

export class LandingPage extends HLF.State {
    private readonly _bg: PIXI.Sprite;
    private readonly _playBtn: Button;

    public constructor() {
        super();

        this.onPlayBtnPressed = this.onPlayBtnPressed.bind(this);

        this._bg = makeSprite("splash/splash-background");
        this.addChild(this._bg);

        const luna = this.addChild(makeSprite("splash/splash-luna"));
        luna.position.set(514.5 - 832, 593 - 384 + (424 - 350) / 2);

        const logo = this.addChild(makeSprite("splash/splash-logo"));
        logo.position.set(-332.75 + (321.7 / 4), 209.25 - 384);

        this._playBtn = new Button(
            this.onPlayBtnPressed,
            "splash/splash-play",
            undefined,
            undefined,
            "ui_click",
        );
        this._playBtn.alpha = 0;
        this._playBtn.interactive = false;
        this._playBtn.position.set(0.25, 64.25);
        this.addChild(this._playBtn);
    }

    public init(pSize: PIXI.Point, pData?: any) {
        super.init(pSize, pData);
        PubSub.publishSync(HLF.PUSH_KEYBOARD_LAYER, undefined);
        Application.instance.analytics?.event("startGame", "lunas-adventures");
    }

    public animateIn(pOnComplete: () => void): void {

        // @ts-ignore
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (AudioContext) {
            const context = new AudioContext();
            // only play intro VO if audio was unlocked
            if (context.state === "running") {
                Application.instance.voiceover.playVO(VO.UI.LANDING_PAGE.UI1);
            }
        }

        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._playBtn, 0.5, {
            alpha: 1,
        });
        timeline.call(() => {
            this._playBtn.interactive = true;
            PubSub.publishSync(HLF.REGISTER_FOCUSABLE, this._playBtn);
            this._bg.interactive = true;
            this._bg.once(HLF.Input.Events.POINTER_TAP, this.onPlayBtnPressed);
        });
        timeline.call(pOnComplete);
    }

    public animateOut(pOnComplete: () => void): void {
        PubSub.publishSync(HLF.POP_KEYBOARD_LAYER, undefined);
        this._playBtn.interactive = false;
        this._bg.off(HLF.Input.Events.POINTER_TAP, this.onPlayBtnPressed);
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._playBtn, 0.5, {
            alpha: 0,
        })
        .call(pOnComplete);
    }

    private onPlayBtnPressed(): void {
        Application.instance.analytics?.event("LandingPage", "StartButtonClicked");
        Application.instance.analytics?.event("clickPlay", "lunas-adventures");
        PubSub.publishSync(HLF.UNREGISTER_FOCUSABLE, this._playBtn);

        const music = Application.instance.audio.getAudioTrack(bgm, HLF.AudioCategory.BGM);
        music?.setLooped(true);
        music?.setVolume(0.125);
        if (!(music?.isPlaying())) {
            music?.play();
        }
        else if (!music) {
            Application.instance.audio.play(bgm, 0.5, true, HLF.AudioCategory.BGM);
        }

        PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
            {id: Constants.STATE_CITY_SELECT, data: {firstTime: true}},
            Constants.LOAD_INTERSTITIAL, ...Constants.DEFAULT_TRANSITION,
        ));
    }
}
